<div class="row g-2">
  <div class="col-6">
    <ng-select
      [items]="times"
      [multiple]="false"
      [clearable]="false"
      [formControl]="timesControl"
      class="form-control"
      bindLabel="name"
      bindValue="name"></ng-select>
  </div>
  <div class="col-6">
    <ng-select
      [items]="meridian"
      [multiple]="false"
      [clearable]="false"
      [formControl]="meridianControl"
      class="form-control"
      bindLabel="name"
      bindValue="name"></ng-select>
  </div>
</div>
